import { ProductoExterno, ProductoInterno } from '../../../../types/responses-novedades'

export enum NovedadControlEnum {
  IDLE = 0,
  Aplicar = 1,
  Descartar = 2
}

export interface NovedadControl {
  nombre: NovedadControlEnum
  descripcion: NovedadControlEnum
  precio: NovedadControlEnum
  fotos: NovedadControlEnum
}

export type NovedadCamposAChequear = 'nombre' | 'descripcion' | 'precio' | 'fotos'
export const AttrsMapear: NovedadCamposAChequear[] = ['nombre', 'descripcion', 'precio', 'fotos']

export interface NovedadDiferencias {
  productoAA1T: ProductoInterno
  productoTienda: ProductoExterno
  attr: NovedadCamposAChequear
  onChange: (attr: NovedadCamposAChequear, value: NovedadControlEnum) => void
  control: NovedadControl
  loading: boolean
  // productoExternoFotos: {
  //   id: number
  //   name: string
  //   src: string
  // }[]
}

export interface NovedadActions {
  onChange: (attr: NovedadCamposAChequear, value: NovedadControlEnum) => void
  control: NovedadControl
  attr: NovedadCamposAChequear
  disabled: boolean
  applyText?: string
  denyText?: string
}
